<template>
	<div style="height: 100%">
		<LeftNavBar :title="selectedAppInitial" :items="sidebarItems" @opened="selectFormType"
			:selectedValue="selectedNav" />
	</div>
</template>

<script>
import LeftNavBar from "bh-mod/components/common/LeftNavBar";

export default {
	components: { LeftNavBar },
	name: "menu-left",
	data: () => ({}),
	watch: {
		selectedNav(val) {
			this.updateCrumbs(val);
		},
	},
	computed: {
		selectedNav() {
			return this.$route.path.split("/")[1] || "";
		},
		instance() {
			return this.$store.state.instance;
		},
		isAIEnabled() {
			return this.$store.getters.isAIEnabled;
		},
		sidebarItems() {
			if (this.$p <= 10) {
				return [
					{
						label: "Lead Report",
						value: "lead",
						iconUrl: require("@/assets/sideIcons/lead.svg"),
					},
					{
						label: "Pipeline Report",
						value: "pipeline",
						iconUrl: require("@/assets/sideIcons/pipeline.svg"),
					},
					{
						label: "Sales Report",
						value: "sales",
						iconUrl: require("@/assets/sideIcons/sales.svg"),
					},
				];
			} else if (this.$p <= 20) {
				const items = [
					{
						label: "Email Report",
						value: "email",
						iconUrl: require("@/assets/sideIcons/email.svg"),
					},
					{
						label: "SMS Report",
						value: "sms",
						iconUrl: require("@/assets/sideIcons/sms.svg"),
					},
					{
						label: "AI Report",
						value: "ai",
						iconUrl: require("@/assets/sideIcons/AI.svg"),
					},
					{
						label: "Lead Report",
						value: "lead",
						iconUrl: require("@/assets/sideIcons/lead.svg"),
					},
					{
						label: "Pipeline Report",
						value: "pipeline",
						iconUrl: require("@/assets/sideIcons/pipeline.svg"),
					},
					{
						label: "Sales Report",
						value: "sales",
						iconUrl: require("@/assets/sideIcons/sales.svg"),
					},
				];
				if (!this.isAIEnabled) {
					return items.filter(x => x.value !== 'ai');
				}
				return items;
			}
			const items = [
				{
					label: "Email Report",
					value: "email",
					iconUrl: require("@/assets/sideIcons/email.svg"),
				},
				{
					label: "SMS Report",
					value: "sms",
					iconUrl: require("@/assets/sideIcons/sms.svg"),
				},
				{
					label: "AI Report",
					value: "ai",
					iconUrl: require("@/assets/sideIcons/AI.svg"),
				},
				{
					label: "Lead Report",
					value: "lead",
					iconUrl: require("@/assets/sideIcons/lead.svg"),
				},
				{
					label: "Pipeline Report",
					value: "pipeline",
					iconUrl: require("@/assets/sideIcons/pipeline.svg"),
				},
				{
					label: "Inventory Report",
					value: "inventory",
					iconUrl: require("@/assets/sideIcons/inventory.svg"),
				},
				{
					label: "Sales Report",
					value: "sales",
					iconUrl: require("@/assets/sideIcons/sales.svg"),
				},
				{
					label: "Deposits Report",
					value: "deposits",
					iconUrl: require("@/assets/sideIcons/deposit.svg"),
				},
				{
					label: "Survey Report",
					value: "survey",
					iconUrl: require("@/assets/sideIcons/survey.svg"),
				},
				{
					label: "Tasks Report",
					value: "tasks",
					iconUrl: require("@/assets/sideIcons/tasks.svg"),
				},
			];

			if (this.instance.package?.itemCode !== 'PA-COM-LRS') {
				items.push({
					label: "Website Report",
					value: "website",
					iconUrl: require("@/assets/sideIcons/website.svg"),
				})
			}

			if (this.$store.getters.isWorksheetActive) {
				items.push({
					label: "Agent Commission Report",
					value: "agentCommission",
					iconUrl: require("@/assets/sideIcons/agentCommission.svg"),
				})
			}

			items.push({
				label: "Marketing Workflow Report",
				value: "marketingWorkflow",
				iconUrl: require("@/assets/sideIcons/marketingWorkflow.svg"),
			});

			if (!this.isAIEnabled) {
				return items.filter(x => x.value !== 'ai');
			}
			return items;
		},
		crumbs() {
			return this.$store.state.inventory.crumbs;
		},
		selectedAppInitial() {
			return this.$store.state.theApp?.media?.initial || "RA";
		},
	},
	methods: {
		updateCrumbs(value) {
			const crumbs = this.sidebarItems.find(
				(item) => item.value === value
			);
			if (crumbs) {
				this.$store.commit("UPDATE_CRUMBS", crumbs.label);
			}
		},

		selectFormType(data) {
			let val = data.value;
			if (this.$route.path != "/" + val) {
				this.$router.push("/" + val);
				this.updateCrumbs(val);
			}
		},
	},
	created() {
		this.updateCrumbs(this.$route.path.substr(1).split("/")[0]);
	},
};
</script>
